
import client from '../../common/client';
import {
    taxpayerTypeDataSource,
    companyDataSource,
    areaIndexDataSource,
    serviceTypeDataSource
} from '../../pages/data/cbs';

export const regionMixin = {
    data() {
        return {
            regionDatasource: [],
            staticRegionData: [],
            nameToCode: {}
        };
    },

    methods: {
        getRegion() {
            return this.getStaticData().then(staticDataResponse => {
                if (staticDataResponse && staticDataResponse.status === 200 && staticDataResponse.data) {
                    const {nameToCode} = staticDataResponse.data;
                    this.staticRegionData = staticDataResponse.data;
                    this.nameToCode = nameToCode;
                }
            });
        },

        convertRegionDataToGroupData(cities, comRegPreferentialCities = []) {
            let result = [];
            cities.forEach(item => {
                let groupLabel = item.groupName;
                let options = [];
                item.groupItems.forEach(groupItem => {
                    groupItem.rowItems.forEach(rowItem => {
                        options.push({
                            label: rowItem,
                            value: parseInt(this.nameToCode[rowItem], 10),
                            isSpecialCity: comRegPreferentialCities.includes(rowItem)
                        });
                    });
                });
                result.push({
                    label: groupLabel,
                    options
                });
            });
            return result;
        },

        getStaticData() {
            return new Promise(resolve => {
                client.queryStaticData().then(res => {
                    resolve(res);
                });
            });
        }
    }
};

export const crsDetailMixin = {
    data() {
        return {
            baseInfo: {
                price: 0
            },
            pkgCityGroups: [],
            nameToCode: {},
            regionDatasource: [],
            companyRegionDatasource: [],
            packageRegionDatasource: []
        };
    },

    methods: {
        getUrlParam() {
            // 参数与console购买页保持一致
            // 服务地区：area【中文】   纳税人类型：taxpayerType【中文】   公司性质：comType【中文】
            // 服务类型：areaIndex【2: 公司注册，4: 公司注册超值套餐，6: 公司注册无忧套餐】
            // 抢注名称：comName
            const {area, taxpayerType, comType, areaIndex, comName} = this.$route.query;
            if (this.isInRegionDatasource(this.regionDatasource, this.nameToCode[area])) {
                this.formData.regionCode = +this.nameToCode[area];
            }
            if (this.isInTextDatasource(taxpayerTypeDataSource, taxpayerType)) {
                this.formData.taxpayerType = taxpayerType;
            }
            if (this.isInTextDatasource(companyDataSource, comType)) {
                this.formData.companyType = comType;
            }
            if (comName) {
                this.formData.comName = comName;
            }
            let serviceType;
            Object.keys(areaIndexDataSource).map(key => {
                if (+areaIndex === areaIndexDataSource[key]) {
                    serviceType = key;
                }
            });
            if (this.isInTextDatasource(serviceTypeDataSource, serviceType)) {
                this.formData.serviceType = serviceType;
            }
            this.setRegionDatasource();
        },

        isInTextDatasource(datasource, data) {
            for (let i = 0; i < datasource.length; i++) {
                if (data === datasource[i].value) {
                    return true;
                }
            }
            return false;
        },

        setRegionToSource(cities) {
            let result = [];
            cities.forEach(item => {
                let groupLabel = item.groupName;
                let options = [];
                item.groupItems.forEach(groupItem => {
                    groupItem.rowItems.forEach(rowItem => {
                        options.push({
                            label: rowItem,
                            value: parseInt(this.nameToCode[rowItem], 10)
                        });
                    });
                });
                result.push({
                    label: groupLabel,
                    options
                });
            });
            return result;
        },

        isInRegionDatasource(regionDatasource, regionCode) {
            for (let i = 0; i < regionDatasource.length; i++) {
                for (let k = 0; k < regionDatasource[i].options.length; k++) {
                    if (+regionDatasource[i].options[k].value === +regionCode) {
                        return true;
                    }
                }
            }
            return false;
        },

        setRegionDatasource() {
            const {serviceType, regionCode} = this.formData;
            this.regionDatasource = serviceType === 'COMPANY_REGISTRATION'
                ? this.companyRegionDatasource
                : this.packageRegionDatasource;

            this.isInRegionDatasource(this.regionDatasource, regionCode);

            if (!this.isInRegionDatasource(this.regionDatasource, regionCode)) {
                const data = this.regionDatasource[0].options[0] || {};
                this.formData.regionCode = data.value || '';
            }

            this.setCompanyDataSource();
        },

        onSelect(type, item) {
            if (this.formData[type] === item) {
                return;
            }
            this.formData[type] = item;
            switch (type) {
                case 'serviceType':
                    this.setRegionDatasource();
                    break;
                default:
                    break;
            }
            this.queryPrice();
        },

        getRegionLabelFromValue() {
            const regionDatasource = this.regionDatasource;
            const {regionCode} = this.formData;
            let label = '';
            regionDatasource.map(item => {
                item.options.map(region => {
                    if (region.value === regionCode) {
                        label = region.label;
                    }
                });
            });
            return label;
        },

        setCompanyDataSource() {
            let {regionCode, companyType, serviceType} = this.formData;
            let _companyDataSource = companyDataSource;
            const area = this.getRegionLabelFromValue(regionCode);
            const {disabledGroupArea, disabledSharesArea} = this.comRegDisableArea;
            if (disabledGroupArea
                && disabledGroupArea.indexOf(area) !== -1
                && serviceType === 'COMPANY_REGISTRATION')
            {
                _companyDataSource = _companyDataSource.filter(item => item.value !== '集团公司');
                companyType = companyType === '集团公司' ? '有限公司' : companyType;
            }
            if (disabledSharesArea
                && disabledSharesArea.indexOf(area) !== -1
                && serviceType === 'COMPANY_REGISTRATION')
            {
                _companyDataSource = _companyDataSource.filter(item => item.value !== '股份有限公司');
                companyType = companyType === '股份有限公司' ? '有限公司' : companyType;
            }
            this.formData.companyType = companyType;
            this.companyDataSource = _companyDataSource;
        },

        // 查询价格
        async queryPrice() {
            const {serviceType, regionCode, taxpayerType, companyType} = this.formData;
            if (serviceType === 'COMPANY_REGISTRATION') {
                const {data}  = await client.getCbsComregPrice({
                    area: regionCode,
                    taxpayerType,
                    comType: companyType
                });
                this.baseInfo.price = data.price + '元';
            }
            else {
                const {data}  = await client.getCbsPackagePrice({
                    area: regionCode,
                    taxpayerType,
                    comType: companyType,
                    packageType: serviceType === 'SUPER_VALUE' ? 1 : 2
                });
                this.baseInfo.price = data.price + '元';
            }
        },

        // 监听地区发生变化
        onRegionChange() {
            this.setCompanyDataSource();
            this.queryPrice();
        }
    }
};

export const sendCodeMixin = {
    data() {
        return {
            codeCountDown: 60,
            codeTimer: null,
            isClickSend: false
        };
    },

    methods: {
        getVerifyCodeMixin(phone) {
            if (this.isClickSend || this.codeCountDown !== 60) {
                return;
            }
            this.isClickSend = true;
            client.getBkpVerifyCode({phone}).then(() => {
                this.codeCountDown -= 1;
                this.codeTimer = setInterval(() => {
                    if (this.codeCountDown <= 1) {
                        this.clearCodeTimer();
                        return;
                    }
                    this.codeCountDown -= 1;
                }, 1000);
            });
        },

        clearCodeTimer() {
            clearInterval(this.codeTimer);
            this.codeTimer = null;
            this.codeCountDown = 60;
            this.isClickSend = false;
        }
    },

    beforeDestroy() {
        this.clearCodeTimer();
    }
};